/* MIAM — thème Shopify « Le menu » — comportement commun à toutes les pages.
   Repris de la maquette V1 : tiroir du menu, couleurs qui changent dans l'assiette,
   choix de la taille, formules, addition. Le panier est celui de Shopify. */
(function () {
  "use strict";

  var M = window.MIAM || {};
  var euros = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
  function prix(centimes) { return euros.format(centimes / 100); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function param(nom) {
    var m = new RegExp("[?&]" + nom + "=([^&#]*)").exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null;
  }

  /* ---------- Le dessin change de couleur ---------- */
  function teinteDetail(hex) {
    var h = hex.replace("#", "");
    var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b < 0.36 ? "rgba(255,255,255,.3)" : "rgba(20,14,8,.32)";
  }
  function recolorer(svg, hex, nom) {
    if (!svg || !hex) return;
    svg.style.setProperty("--teinte", hex);
    svg.style.setProperty("--detail", teinteDetail(hex));
    var label = svg.getAttribute("aria-label") || "";
    svg.setAttribute("aria-label", label.split(",")[0] + ", " + nom);
  }

  /* Sert la pièce dans la couleur du bouton : sa photo si elle en a une, sinon le dessin recoloré. */
  function servir(zone, bouton) {
    if (!zone || !bouton) return;
    var nom = bouton.getAttribute("data-couleur") || bouton.getAttribute("data-teinte");
    var photo = bouton.getAttribute("data-photo");
    var img = $("[data-photo-cible]", zone), dessin = $("[data-dessin]", zone);
    recolorer($(".vetement", zone), bouton.getAttribute("data-hex"), nom);
    if (!img) return;
    if (photo) {
      img.src = photo;
      img.alt = (img.alt || "").split(",")[0] + ", " + nom;
      img.hidden = false;
      if (dessin) dessin.setAttribute("hidden", "");
    } else {
      img.hidden = true;
      if (dessin) dessin.removeAttribute("hidden");
    }
    var loupe = $("[data-loupe]", zone);
    if (loupe) loupe.hidden = !photo;
  }

  /* ---------- Compteur et notification ---------- */
  function majCompteur(n, anime) {
    $$("[data-compteur]").forEach(function (el) {
      el.textContent = n;
      if (anime) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
  }
  var toastEl, toastMinuteur;
  function toast(message, sansLien) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      toastEl.setAttribute("aria-live", "polite");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = "";
    var texte = document.createElement("span");
    texte.textContent = message;
    var lien = document.createElement("a");
    lien.href = M.panier;
    lien.textContent = "Voir l'addition";
    toastEl.appendChild(texte);
    if (!sansLien) toastEl.appendChild(lien);
    void toastEl.offsetWidth;
    toastEl.classList.add("visible");
    clearTimeout(toastMinuteur);
    toastMinuteur = setTimeout(function () { toastEl.classList.remove("visible"); }, 3800);
  }

  /* ---------- Le panier Shopify ---------- */
  function requete(url, corps) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || "Impossible d'ajouter cette pièce.");
        return j;
      });
    });
  }
  function rafraichirCompteur(anime) {
    return fetch(M.panier + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (panier) { majCompteur(panier.item_count, anime); });
  }
  function ajouter(articles) {
    return requete(M.ajouter, { items: articles }).then(function () { return rafraichirCompteur(true); });
  }

  /* ---------- Tiroir du menu ---------- */
  function initTiroir() {
    var bouton = $(".entete__menu"), tiroir = $("#tiroir");
    if (!bouton || !tiroir) return;
    function ouvrir() { tiroir.hidden = false; bouton.setAttribute("aria-expanded", "true"); var a = $("a", tiroir); if (a) a.focus(); }
    function fermer(rendreFocus) { tiroir.hidden = true; bouton.setAttribute("aria-expanded", "false"); if (rendreFocus) bouton.focus(); }
    bouton.addEventListener("click", ouvrir);
    tiroir.addEventListener("click", function (e) {
      if (e.target === tiroir || e.target.hasAttribute("data-fermer-tiroir")) fermer(true);
      else if (e.target.closest("a")) fermer(false);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !tiroir.hidden) fermer(true); });
  }

  /* ---------- Petites fenêtres (balise dialog) : « data-ouvre » les ouvre, la croix ou un clic à côté les ferme ---------- */
  /* Laisse le temps au carton de repartir (animation « reprendre » de miam.css) avant de fermer pour de bon. */
  function fermerFenetre(f) {
    if (!f.open || f.classList.contains("part")) return;
    f.classList.add("part");
    setTimeout(function () { f.classList.remove("part"); if (f.open) f.close(); }, 230);
  }
  function initFenetres() {
    document.addEventListener("click", function (e) {
      var ouvre = e.target.closest("[data-ouvre]");
      if (ouvre) {
        var cible = document.getElementById(ouvre.getAttribute("data-ouvre"));
        if (cible && typeof cible.showModal === "function") { e.preventDefault(); if (!cible.open) cible.showModal(); }
        return;
      }
      var f = e.target.closest("dialog[data-fenetre]");
      if (f && f.open && (e.target === f || e.target.closest("[data-fermer-fenetre]"))) fermerFenetre(f);
    });
  }

  /* ---------- Avis clients (application Judge.me) ---------- */
  function initAvis() {
    /* Le formulaire demande un prénom plutôt qu'un « nom d'affichage ». Judge.me lit ces réglages au moment
       où il construit le formulaire et la liste des avis : on les remplace avant. (L'option « avis anonyme » est masquée dans miam.css.)
       Dates à la française (jour/mois/année) et, pour les avis signés d'un nom complet, le prénom suivi de l'initiale. */
    var essais = 0;
    (function textes() {
      var s = window.jdgmSettings;
      if (s) {
        s.widget_name_field_text = "Ton prénom"; s.widget_name_placeholder_text = "Ton prénom";
        s.review_date_format = "dd/mm/yyyy";
        s.widget_reviewer_name_as_initial = "last_initial";
        s.all_reviews_widget_v2025_reviewer_name_as_initial = "last_initial";
      }
      else if (++essais < 20) setTimeout(textes, 300);
    })();
    /* Arrivée depuis « Signer le livre d'or » (…?avis=1) : le formulaire d'avis de la pièce s'ouvre tout seul. */
    if (param("avis") !== "1") return;
    var tours = 0, minuteur = setInterval(function () {
      var bouton = $("#judgeme_product_reviews [data-testid='write-review-button']");
      if (bouton) {
        clearInterval(minuteur);
        var section = $("#avis");
        if (section) section.scrollIntoView();
        bouton.click();
      } else if (++tours > 48) clearInterval(minuteur);
    }, 250);
  }

  /* ---------- Fenêtre de bienvenue : une seule fois, sur la première page que le visiteur ouvre ---------- */
  function initBienvenue() {
    function fenetre() { var f = $("[data-bienvenue]"); return f && typeof f.showModal === "function" ? f : null; }
    var fermer = fermerFenetre;
    document.addEventListener("click", function (e) {
      var f = fenetre();
      if (!f || !f.open) return;
      var bouton = e.target.closest("[data-code-sur-place]");
      if (bouton && f.contains(bouton)) {
        /* Hors de l'accueil : le code est noté sans quitter la page. Si la requête échoue, le lien fait le travail. */
        e.preventDefault();
        fetch(bouton.getAttribute("data-code-sur-place"), { credentials: "same-origin" }).then(function (r) {
          if (!r.ok) throw new Error("code");
          fermer(f);
          toast(bouton.getAttribute("data-message") || bouton.getAttribute("data-code") + " noté : −" + bouton.getAttribute("data-remise") + " sur ton addition", true);
        }).catch(function () { location.href = bouton.href; });
      } else if (e.target === f || e.target.closest("[data-fermer-bienvenue]")) fermer(f);
    });
    /* Dans l'éditeur de thème : elle s'ouvre quand on sélectionne sa section, pour pouvoir la relire. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:section:select", function (e) {
        var f = fenetre();
        if (f && e.target.contains(f) && !f.open) f.showModal();
      });
      document.addEventListener("shopify:section:deselect", function () { var f = fenetre(); if (f && f.open) f.close(); });
      return;
    }
    var f = fenetre();
    /* Pas de bienvenue par-dessus le formulaire d'avis (arrivée par « …?avis=1 ») : ce sera pour la page suivante. */
    if (!f || param("avis") === "1") return;
    f.addEventListener("cancel", function (e) { e.preventDefault(); fermer(f); });
    var cle = "miam-bienvenue";
    try { if (localStorage.getItem(cle)) return; } catch (e) { return; }
    /* Le bandeau de consentement aux cookies (celui de Shopify) passe d'abord : la bienvenue attend qu'il soit refermé,
       pour ne pas empiler deux fenêtres sous le nez d'un nouveau visiteur. */
    var arrivee = Date.now();
    function cookiesOuverts() {
      var bandeau = document.getElementById("shopify-pc__banner");
      if (bandeau) return getComputedStyle(bandeau).display !== "none";
      /* pas encore dans la page : pendant 4 s, on se fie à Shopify pour savoir s'il va s'afficher */
      var regles = window.Shopify && window.Shopify.customerPrivacy;
      try { return Date.now() - arrivee < 4000 && !!(regles && regles.shouldShowBanner && regles.shouldShowBanner()); } catch (e) { return false; }
    }
    (function tenter(delai, attendu) {
      setTimeout(function () {
        var tiroir = $("#tiroir");
        if (f.open) return;
        if (cookiesOuverts()) return tenter(400, true);
        if (attendu) return tenter(600, false);          /* le bandeau vient de se fermer : on laisse souffler */
        if (tiroir && !tiroir.hidden) return;
        try { localStorage.setItem(cle, "1"); } catch (e) { return; }
        f.showModal();
      }, delai);
    })(700, false);
  }

  /* ---------- La carte : pastilles de couleur et filtres ---------- */
  function initCarte() {
    var grille = $("[data-grille]");
    if (!grille) return;
    grille.addEventListener("click", function (e) {
      var b = e.target.closest("[data-teinte]");
      if (!b) return;
      var carte = b.closest(".plat"), nom = b.getAttribute("data-teinte");
      servir(carte, b);
      $$("[data-teinte]", carte).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      var lien = $(".plat__lien", carte);
      if (lien) lien.setAttribute("href", carte.getAttribute("data-url") + "?couleur=" + encodeURIComponent(nom));
    });

    var filtres = $("[data-filtres]");
    if (!filtres) return;
    function filtrer(valeur) {
      $$("[data-filtre]", filtres).forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-filtre") === valeur)); });
      $$(".plat[data-service]", grille).forEach(function (el) {
        el.hidden = valeur !== "tout" && el.getAttribute("data-service") !== valeur;
      });
    }
    filtres.addEventListener("click", function (e) {
      var b = e.target.closest("[data-filtre]");
      if (b) filtrer(b.getAttribute("data-filtre"));
    });
    var h = location.hash.replace("#", "");
    if (["entree", "plat", "dessert", "accompagnement", "formule"].indexOf(h) > -1) {
      filtrer(h);
      var choisi = $("[data-filtre='" + h + "']", filtres);
      if (choisi) filtres.scrollLeft += choisi.getBoundingClientRect().left - filtres.getBoundingClientRect().left - 16;
    }
  }

  /* ---------- Choisir couleur et taille : commun à la fiche produit et aux formules ---------- */
  function Choix(el, surChangement) {
    var brut = $("[data-variantes]", el);
    var d = brut ? JSON.parse(brut.textContent) : { variantes: [], ic: -1, it: -1 };
    var etat = { couleur: null, taille: null };
    var boutonsCouleur = $$("[data-couleur]", el), boutonsTaille = $$("[data-taille]", el);
    var aCouleur = d.ic > -1 && boutonsCouleur.length > 0, aTaille = d.it > -1 && boutonsTaille.length > 0;

    function variante() {
      return d.variantes.filter(function (v) {
        return (!aCouleur || v.o[d.ic] === etat.couleur) && (!aTaille || v.o[d.it] === etat.taille);
      })[0] || null;
    }
    function majTailles() {
      boutonsTaille.forEach(function (b) {
        var t = b.getAttribute("data-taille");
        var dispo = d.variantes.some(function (v) { return v.o[d.it] === t && (!aCouleur || v.o[d.ic] === etat.couleur) && v.dispo; });
        b.disabled = !dispo;
        if (!dispo && etat.taille === t) etat.taille = null;
        b.setAttribute("aria-pressed", String(etat.taille === t));
      });
    }
    function choisirCouleur(nom) {
      var b = boutonsCouleur.filter(function (x) { return x.getAttribute("data-couleur") === nom; })[0];
      if (!b) return;
      etat.couleur = nom;
      boutonsCouleur.forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      servir(el.closest("[data-produit]") || el, b);
      majTailles();
      surChangement && surChangement(api);
    }
    function choisirTaille(t) {
      etat.taille = t;
      majTailles();
      surChangement && surChangement(api);
    }
    el.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b || !el.contains(b)) return;
      if (b.hasAttribute("data-couleur")) choisirCouleur(b.getAttribute("data-couleur"));
      else if (b.hasAttribute("data-taille") && !b.disabled) choisirTaille(b.getAttribute("data-taille"));
    });

    var api = {
      el: el,
      titre: d.titre,
      etat: etat,
      aTaille: aTaille,
      complet: function () { return (!aTaille || !!etat.taille) && !!variante(); },
      variante: variante,
      choisirCouleur: choisirCouleur
    };
    if (aCouleur) {
      var depart = boutonsCouleur.filter(function (x) { return x.getAttribute("aria-pressed") === "true"; })[0] || boutonsCouleur[0];
      etat.couleur = depart.getAttribute("data-couleur");
    }
    majTailles();
    return api;
  }

  /* ---------- Fiche produit ---------- */
  function initProduit() {
    var page = $("[data-produit]");
    if (!page) return;
    var zone = $("[data-choix]", page), barre = $("[data-barre]");
    var erreur = $("[data-erreur]", page), bouton = $("[data-commander]", page);
    var boutons = $$("[data-commander], [data-addition]", page).concat(barre ? $$("button", barre) : []);

    function resume(c) {
      var morceaux = [];
      if (c.etat.couleur) morceaux.push(c.etat.couleur);
      morceaux.push(c.aTaille ? (c.etat.taille ? "taille " + c.etat.taille : "choisis ta taille") : "");
      return morceaux.filter(Boolean).join(" · ");
    }
    var choix = Choix(zone, function (c) {
      var nom = $("[data-nom-couleur]", page);
      if (nom && c.etat.couleur) nom.textContent = c.etat.couleur;
      if (erreur) erreur.textContent = "";
      var v = c.variante();
      if (v) {
        $$("[data-prix], [data-prix-bouton]", page).forEach(function (el) { el.textContent = prix(v.prix); });
      }
      $$("[data-media]", page).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      if (barre) $("[data-barre-choix]", barre).textContent = resume(c);
    });
    var voulue = param("couleur");
    if (voulue) choix.choisirCouleur(voulue);
    if (barre) $("[data-barre-choix]", barre).textContent = resume(choix);

    /* Deux boutons : le premier ajoute la pièce et laisse sur la page, le second l'ajoute et ouvre l'addition.
       Si la pièce choisie est déjà sur l'addition, le second y mène sans l'ajouter une deuxième fois. */
    function dejaSurAddition(id) {
      return fetch(M.panier + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (panier) { return (panier.items || []).some(function (x) { return x.variant_id === id; }); })
        .catch(function () { return false; });
    }
    function commander(versAddition) {
      if (!choix.complet()) {
        if (erreur) erreur.textContent = "Choisis ta taille pour commander.";
        var t = $("[data-tailles]", page);
        if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      var v = choix.variante();
      boutons.forEach(function (b) { b.disabled = true; });
      (versAddition ? dejaSurAddition(v.id) : Promise.resolve(false)).then(function (deja) {
        return deja ? null : ajouter([{ id: v.id, quantity: 1 }]);
      }).then(function () {
        if (versAddition) { location.href = M.panier; return; }
        toast([choix.titre, (choix.etat.couleur || "").toLowerCase(), choix.etat.taille].filter(Boolean).join(", ") + " : ajouté");
      }).catch(function (e) {
        if (erreur) erreur.textContent = e.message;
      }).then(function () { boutons.forEach(function (b) { b.disabled = false; }); });
    }
    function brancher(b, versAddition) {
      if (b) b.addEventListener("click", function () { commander(versAddition); });
    }
    brancher(bouton, false);
    brancher($("[data-addition]", page), true);

    /* Les trois vues provisoires (dessin, vidéo, matière) tant qu'il n'y a pas de photo */
    page.addEventListener("click", function (e) {
      var b = e.target.closest("[data-vue]");
      if (b) {
        var vue = b.getAttribute("data-vue");
        $$("[data-vue]", page).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        $$("[data-vue-contenu]", page).forEach(function (x) { x.hidden = x.getAttribute("data-vue-contenu") !== vue; });
        return;
      }
      var f = e.target.closest("[data-fleche]");
      if (f) { avancer(parseInt(f.getAttribute("data-fleche"), 10)); return; }
      if (e.target.closest("[data-loupe]") || e.target.closest("[data-photo-cible]")) { ouvrirZoom(); return; }
      var m = e.target.closest("[data-media]");
      if (m) montrer(m);
    });

    /* La galerie : les miniatures, les flèches et le glissé du doigt montrent la même liste de photos */
    var medias = $$("[data-media]", page);
    function fichier(adresse) { return (adresse || "").split("?")[0].split("/").pop(); }
    function montrer(m) {
      var photo = $("[data-photo-cible]", page), dessin = $("[data-dessin]", page);
      if (photo) { photo.src = m.getAttribute("data-src"); photo.hidden = false; }
      if (dessin) dessin.setAttribute("hidden", "");
      medias.forEach(function (x) { x.setAttribute("aria-pressed", String(x === m)); });
      var bouton = $("[data-loupe]", page);
      if (bouton) bouton.hidden = false;
      var bande = m.parentNode;
      if (bande.scrollWidth > bande.clientWidth) bande.scrollLeft = m.offsetLeft - bande.offsetLeft - (bande.clientWidth - m.offsetWidth) / 2;
    }
    /* Photo affichée : la miniature active, sinon celle qui correspond à l'image en place (après un changement de couleur) */
    function position() {
      var photo = $("[data-photo-cible]", page), i = -1;
      medias.forEach(function (x, k) { if (x.getAttribute("aria-pressed") === "true") i = k; });
      if (i < 0 && photo && !photo.hidden) {
        var nom = fichier(photo.getAttribute("src"));
        medias.forEach(function (x, k) { if (i < 0 && nom && fichier(x.getAttribute("data-src")) === nom) i = k; });
      }
      return i;
    }
    function avancer(pas) {
      var n = medias.length;
      if (n < 2) return;
      var i = position();
      var cible = i < 0 ? (pas > 0 ? 0 : n - 1) : (i + pas + n) % n;
      montrer(medias[cible]);
      new Image().src = medias[(cible + pas + n) % n].getAttribute("data-src");
    }
    var scene = $("[data-scene]", page), appui = null;
    if (scene && medias.length > 1) {
      scene.addEventListener("touchstart", function (e) {
        appui = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }, { passive: true });
      scene.addEventListener("touchend", function (e) {
        if (!appui) return;
        var dx = e.changedTouches[0].clientX - appui.x, dy = e.changedTouches[0].clientY - appui.y;
        appui = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) avancer(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    /* Zoom : la photo s'ouvre en plein écran ; un clic l'agrandit à l'endroit visé, un second revient à la vue entière */
    var zoom = null, retour = null;
    var souris = !!(window.matchMedia && window.matchMedia("(hover: hover)").matches);
    function adresseZoom(src) {
      if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, "$1width=2400");
      return src + (src.indexOf("?") < 0 ? "?" : "&") + "width=2400";
    }
    function aideZoom() {
      var i = position(), debut = medias.length > 1 && i >= 0 ? (i + 1) + " / " + medias.length + " · " : "";
      var texte = zoom.classList.contains("gros")
        ? (souris ? "Clique pour revenir" : "Touche pour revenir")
        : (souris ? "Clique pour zoomer" : "Touche pour zoomer");
      $("[data-zoom-aide]", zoom).textContent = debut + texte;
    }
    function chargerZoom() {
      var photo = $("[data-photo-cible]", page), img = $("[data-zoom-img]", zoom), src = photo.getAttribute("src");
      zoom.classList.remove("gros");
      img.src = src;
      img.alt = photo.alt;
      var grande = new Image();
      grande.onload = function () { if (photo.getAttribute("src") === src) img.src = grande.src; };
      grande.src = adresseZoom(src);
      aideZoom();
    }
    function basculerZoom(e) {
      var cadre = $("[data-zoom-cadre]", zoom), img = $("[data-zoom-img]", zoom);
      if (zoom.classList.contains("gros")) {
        zoom.classList.remove("gros");
      } else {
        var r = img.getBoundingClientRect();
        var rx = (e.clientX - r.left) / r.width, ry = (e.clientY - r.top) / r.height;
        zoom.classList.add("gros");
        cadre.scrollLeft = rx * img.offsetWidth - cadre.clientWidth / 2;
        cadre.scrollTop = ry * img.offsetHeight - cadre.clientHeight / 2;
      }
      aideZoom();
    }
    function fermerZoom() {
      zoom.classList.remove("ouvert", "gros");
      document.body.classList.remove("zoom-ouvert");
      if (retour && retour.focus) retour.focus();
    }
    function passerZoom(pas) {
      if (medias.length < 2) return;
      avancer(pas);
      chargerZoom();
    }
    function construireZoom() {
      var chevron = function (d) { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
      zoom = document.createElement("div");
      zoom.className = "zoom";
      zoom.setAttribute("role", "dialog");
      zoom.setAttribute("aria-modal", "true");
      zoom.setAttribute("aria-label", "Photo agrandie");
      zoom.innerHTML = '<div class="zoom__cadre" data-zoom-cadre><img class="zoom__img" data-zoom-img alt=""></div>' +
        '<button class="zoom__bouton zoom__fermer" type="button" data-zoom-fermer aria-label="Fermer">' + chevron("M6 6l12 12M18 6L6 18") + "</button>" +
        (medias.length > 1
          ? '<button class="zoom__bouton zoom__avant" type="button" data-zoom-pas="-1" aria-label="Photo précédente">' + chevron("M14.5 5.5 8 12l6.5 6.5") + "</button>" +
            '<button class="zoom__bouton zoom__apres" type="button" data-zoom-pas="1" aria-label="Photo suivante">' + chevron("M9.5 5.5 16 12l-6.5 6.5") + "</button>"
          : "") +
        '<p class="zoom__aide" data-zoom-aide aria-live="polite"></p>';
      document.body.appendChild(zoom);
      var cadre = $("[data-zoom-cadre]", zoom), appuiZoom = null;
      zoom.addEventListener("click", function (e) {
        var p = e.target.closest("[data-zoom-pas]");
        if (p) { passerZoom(parseInt(p.getAttribute("data-zoom-pas"), 10)); return; }
        if (e.target.closest("[data-zoom-fermer]")) { fermerZoom(); return; }
        if (e.target.closest("[data-zoom-img]")) { basculerZoom(e); return; }
        if (!zoom.classList.contains("gros")) fermerZoom();
      });
      cadre.addEventListener("mousemove", function (e) {
        if (!souris || !zoom.classList.contains("gros")) return;
        cadre.scrollLeft = (e.clientX / cadre.clientWidth) * (cadre.scrollWidth - cadre.clientWidth);
        cadre.scrollTop = (e.clientY / cadre.clientHeight) * (cadre.scrollHeight - cadre.clientHeight);
      });
      cadre.addEventListener("touchstart", function (e) {
        appuiZoom = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }, { passive: true });
      cadre.addEventListener("touchend", function (e) {
        if (!appuiZoom || zoom.classList.contains("gros")) { appuiZoom = null; return; }
        var dx = e.changedTouches[0].clientX - appuiZoom.x, dy = e.changedTouches[0].clientY - appuiZoom.y;
        appuiZoom = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) passerZoom(dx < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener("keydown", function (e) {
        if (!zoom.classList.contains("ouvert")) return;
        if (e.key === "Escape") fermerZoom();
        else if (e.key === "ArrowRight") passerZoom(1);
        else if (e.key === "ArrowLeft") passerZoom(-1);
      });
    }
    function ouvrirZoom() {
      var photo = $("[data-photo-cible]", page);
      if (!photo || photo.hidden || !photo.getAttribute("src")) return;
      if (!zoom) construireZoom();
      retour = document.activeElement;
      chargerZoom();
      zoom.classList.add("ouvert");
      document.body.classList.add("zoom-ouvert");
      $("[data-zoom-fermer]", zoom).focus();
    }

    if (barre && bouton) {
      brancher($("[data-commander-barre]", barre), false);
      brancher($("[data-addition-barre]", barre), true);
      if ("IntersectionObserver" in window) {
        /* La barre du bas prend le relais dès que les deux boutons passent sous l'en-tête accroché. */
        var enveloppe = $("#shopify-section-entete"), entete = $(".entete");
        var colle = enveloppe && getComputedStyle(enveloppe).display !== "contents" ? enveloppe : entete;
        var marge = colle ? Math.round(colle.getBoundingClientRect().height) : 0;
        new IntersectionObserver(function (entrees) {
          var visible = !entrees[0].isIntersecting;
          barre.classList.toggle("visible", visible);
          document.body.classList.toggle("barre-visible", visible);
        }, { rootMargin: "-" + marge + "px 0px 0px 0px" }).observe(bouton.closest(".fiche__commande") || bouton);
      }
    }
  }

  /* ---------- Composer sa formule ---------- */
  function initFormules() {
    $$("[data-formule]").forEach(function (bloc) {
      var nom = bloc.getAttribute("data-formule");
      var remise = parseFloat(bloc.getAttribute("data-remise")) || 0;
      var seuil = parseInt(bloc.getAttribute("data-seuil"), 10) || 0;
      var erreur = $("[data-erreur]", bloc), bouton = $("[data-ajouter-formule]", bloc);
      var pret = false;

      /* À chaque étape (entrée, plat, dessert), une pièce est montrée ; les autres pièces du service attendent, cachées. */
      var etapes = $$("[data-service-etape]", bloc).map(function (zone) {
        var pieces = $$("[data-etape]", zone).map(function (el) { return Choix(el, maj); });
        var etape = {
          nom: zone.getAttribute("data-service"),
          active: pieces.filter(function (c) { return !c.el.hidden; })[0] || pieces[0]
        };
        var boutons = $$("[data-piece]", zone);
        boutons.forEach(function (b) {
          b.addEventListener("click", function () {
            pieces.forEach(function (c) {
              var oui = c.el.getAttribute("data-piece-contenu") === b.getAttribute("data-piece");
              c.el.hidden = !oui;
              if (oui) etape.active = c;
            });
            boutons.forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
            maj();
          });
        });
        return etape;
      });

      /* Le total suit les pièces choisies. La remise est calculée pièce par pièce, comme le fait Shopify. */
      function maj() {
        if (!pret) return;
        erreur.textContent = "";
        var carte = 0, net = 0;
        etapes.forEach(function (e) {
          var v = e.active.variante();
          var p = v ? v.prix : parseInt(e.active.el.getAttribute("data-prix"), 10) || 0;
          carte += p;
          net += p - Math.round(p * remise / 100);
        });
        $("[data-total]", bloc).textContent = prix(net);
        $("[data-carte]", bloc).textContent = prix(carte);
        var livraison = $("[data-livraison]", bloc);
        if (livraison) livraison.hidden = net < seuil;
      }
      pret = true;
      maj();

      bouton.addEventListener("click", function () {
        var manque = etapes.filter(function (e) { return !e.active.complet(); });
        if (manque.length) {
          erreur.textContent = "Choisis une taille pour : " + manque.map(function (e) { return e.nom; }).join(", ") + ".";
          return;
        }
        bouton.disabled = true;
        ajouter(etapes.map(function (e) {
          return { id: e.active.variante().id, quantity: 1 };
        })).then(function () {
          toast(nom + " : c'est noté");
        }).catch(function (e) {
          erreur.textContent = e.message;
        }).then(function () { bouton.disabled = false; });
      });
    });
  }

  /* ---------- L'addition ---------- */
  function initAddition() {
    var zone = $("[data-addition]");
    if (!zone) return;
    zone.addEventListener("click", function (e) {
      var b = e.target.closest("[data-ligne]");
      if (!b) return;
      var ticket = $("[data-ticket]", zone);
      if (ticket) ticket.classList.add("charge");
      requete(M.modifier, { id: b.getAttribute("data-ligne"), quantity: parseInt(b.getAttribute("data-quantite"), 10) })
        .then(function (panier) {
          majCompteur(panier.item_count, true);
          return fetch(M.panier + "?section_id=" + encodeURIComponent(zone.getAttribute("data-section")));
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var neuf = new DOMParser().parseFromString(html, "text/html").querySelector("[data-addition]");
          if (neuf) zone.innerHTML = neuf.innerHTML; else location.reload();
        })
        .catch(function () { location.reload(); });
    });
  }

  /* ---------- Apparitions au défilement ---------- */
  function reveler() {
    var els = $$(".revele:not(.vu)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (x) { x.classList.add("vu"); }); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("vu"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (x) { io.observe(x); });
    /* Filet de sécurité : rien ne doit rester invisible dans l'écran si l'observateur tarde. */
    setTimeout(function () {
      $$(".revele:not(.vu)").forEach(function (x) { if (x.getBoundingClientRect().top < window.innerHeight) x.classList.add("vu"); });
    }, 1200);
  }

  function init() {
    initTiroir();
    initFenetres();
    initBienvenue();
    initAvis();
    initCarte();
    initProduit();
    initFormules();
    initAddition();
    reveler();
    var cible = location.hash && document.getElementById(location.hash.slice(1));
    if (cible) setTimeout(function () { cible.scrollIntoView(); }, 60);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
